module.exports = __webpack_public_path__ + "static/img/new_01.d3d7cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_01.jpg
// module id = GRR+
// module chunks = 0